import { Centred, Contents } from '../../styles/mixins'
import { RichText } from '../../styles/mixins'

const styles = theme => ({
  contents: {
    ...Contents(theme),
  },
  centred: {
    ...Centred(theme),
  },
  quoter: {
    height: '100%',
    minHeight: '60vh',
    backgroundImage:
      'linear-gradient(to right top, #051937, #004d7a, #008793, #00bf72, #a8eb12)',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
  },
  quoterMarkLeft: {
    height: 50,
    [theme.breakpoints.down('sm')]: {
      height: 30,
    },
  },
  quoterMarkRight: {
    height: 50,
    float: 'right',
    [theme.breakpoints.down('sm')]: {
      height: 30,
    },
  },
  quoterQuote: {
    color: 'rgba(255,255,255,1)',
    lineHeight: 1.2,
    fontWeight: 100,
    fontSize: theme.typography.subheading.fontSize,
    textAlign: 'center',
    width: '75%',
    margin: 'auto',
  },
  quoterAuthor: {
    marginTop: theme.spacing.unit * 3,
    color: '#fafafa',
    fontSize: theme.typography.body2.fontSize * 0.9,
    fontWeight: 400,
    textAlign: 'center',
    width: '50%',
    margin: 'auto',
  },
  quoterCompany: {
    marginTop: -5,
    color: '#fff',
    fontSize: 16,
    textAlign: 'center',
    width: '50%',
    margin: 'auto',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/quote/styles.js